const headerBn = {
	brand: 'গ্রামীণ বাজার',
	top: {
		bazarList: 'বাজার',
		help: 'সাহায্য',
		contact: 'যোগাযোগ',
	},
	nav: {
		dailyBazar: 'নিত্যপণ্যে',
		medicineBazar: 'ঔষধ',
		foodBazar: 'ফ্রেশ খাবার',
		grains: 'শস্য',
		nationalBazar: 'জাতীয় পণ্য',
		garmentsBazar: 'গার্মেন্টস',
		cosmeticsBazar: 'কসমেটিক্স',
		bookBazar: 'বই',
		nurseryBazar: 'নার্সারি',
		electronicsBazar: 'ইলেক্ট্রনিক্স',
		chemicalBazar: 'কেমিক্যাল',
		hardwareBazar: 'হার্ডওয়্যার',
		serviceBazar: 'সার্ভিস',
		feedBazar: 'পশু খাদ্য',
	},
	search: {
		placeholder: 'কি কেনাকাটা করবেন?'
	},
	drawer: {
		home: 'হোম',
		dailyBazar: 'দৈনন্দিন বাজার',
		medicineBazar: 'ঔষধ বাজার',
		grains: 'শস্য বাজার',
		nationalBazar: 'জাতীয় পণ্য বাজার',
		foodBazar: 'ফ্রেশ খাবার',
		bookBazar: 'বই বাজার',
		nurseryBazar: 'নার্সারি বাজার',
		garmentsBazar: 'গার্মেন্টস বাজার',
		electronicsBazar: 'ইলেক্ট্রনিক্স বাজার',
		chemicalBazar: 'কেমিক্যাল বাজার',
		hardwareBazar: 'হার্ডওয়্যার বাজার',
		cosmeticsBazar: 'কসমেটিক্স বাজার',
		serviceBazar: 'সার্ভিস বাজার',
		feedBazar: 'খাদ্য বাজার',
	},
	profileMenu: {
		login: 'লগইন',
		register: 'রেজিস্টার',
		myAccount: 'আমার অ্যাকাউন্ট',
		storeDashboard: 'স্টোর ড্যাশবোর্ড',
		adminDashboard: 'অ্যাডমিন ড্যাশবোর্ড',
	},
};

export default headerBn;


